import {Component, Input} from "@angular/core";
import {DialogService} from "../bootstrap-modal/dialog.service";
import {SimpleHelpDialogComponent} from "./simple-help-dialog.component";

@Component({
  selector: "help-dialog-button",
  templateUrl: "./help-dialog-button.template.pug",
})
export class HelpDialogButtonComponent {
  @Input()
  fieldName: string;

  @Input()
  helpString: string;

  constructor(private dialogService: DialogService) {}

  showDialog() {
    SimpleHelpDialogComponent.show(this.dialogService, {readableName: this.fieldName, help: this.helpString});
    return false;
  }
}
